/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdStepItemProps, TdStepsProps } from './type';

export const stepItemDefaultProps: TdStepItemProps = { icon: true, status: 'default' };

export const stepsDefaultProps: TdStepsProps = {
  layout: 'horizontal',
  readonly: false,
  readOnly: false,
  separator: 'line',
  sequence: 'positive',
  theme: 'default',
};
